import * as actions from "../actions/actionTypes.js";

const defaultState = {
  productChangePreview: null,
  productChangeValid: false,
  stagedProductChange: {},
  targetGroups: [{ id: "", name: "-" }],
  publicationDays: [], // Build 4.1.0.0 (ERP #10140)
  publishingDaysDate: [], // Build 4.1.0.0 (ERP #10140)
  dynamicProducts: [], // Build 4.1.1.0 (ERP #11124)
  salesmanList: [], // Build 4.1.1.0 (ERP #11124)
};

const subscriptionReducer = (state = defaultState, action) => {
  switch (action.type) {
    case actions.SUBS_SET_TARGET_GROUPS: {
      const targetGroups = action.payload.map((group) => ({
        ...group,
        id: group.codeno,
        name: `${group.codeno} ${group.codevalue}`,
      }));
      return { ...state, targetGroups: [...state.targetGroups, ...targetGroups] };
    }
    case actions._SUBS_SET_STAGED_PRODUCT_CHANGE: {
      return { ...state, stagedProductChange: action.payload };
    }
    case actions._SUBS_SET_CHANGED_PRODUCT_PREVIEW: {
      return { ...state, productChangePreview: action.payload };
    }
    case actions._SUBS_SET_PRODUCT_CHANGE_VALID: {
      return { ...state, productChangeValid: true };
    }
    case actions.SUBS_SET_RENEWING: {
      console.log({action})
      return { ...state, renewingSubscription: action.payload };
    }
    case actions.MOVING_CREDITING_SLEEP_TO_ADVPAYMENT: {
      console.log({action})
      return { ...state, movingCreditingSleepToAdvpayment: action.payload };
    }
    case actions.SUBS_CHANGE_RECEIVER: {
      console.log({action})
      return { ...state, changingReceiver: action.payload };
    }
    case actions.SUBS_SET_ENDING_UNPAID: {
      console.log({action})
      return { ...state, endingUnpaidSubscription: action.payload };
    }
    case actions.SUBS_SET_RESTARTING_UNPAID: {
      console.log({action})
      return { ...state, restartingUnpaidSubscription: action.payload };
    }
    case actions.SUBS_SET_RESTARTING_CANCELLED: {
      console.log({action})
      return { ...state, restartingCancelledSubscription: action.payload };
    }
    case actions.SUBS_SET_CLEARING_DEBT: {
      console.log({action})
      return { ...state, clearingDebtForSubscription: action.payload };
    }
    // Build 4.1.2.0 (ERP #10512)
    case actions._SUBS_CLEAR_PRODUCT_CHANGE_PREVIEW: {
      return {
        ...state,
        stagedProductChange: {},
        productChangePreview: {},
        productChangeValid: false,
      };
    }
    // Build 4.1.0.0 (ERP #10140)
    case actions.SET_PUBLICATION_DAYS: {
      return { ...state, publicationDays: action.publicationDays };
    }
    case actions.SEARCHING_SUBS: {
      return { ...state, searchingSubs: action.payload };
    }
    // Build 4.1.0.0 (ERP #10140)
    case actions.SET_PUBLISHINGDAYSDATE: {
      return { ...state, publishingDaysDate: action.publishingDaysDate };
    }
    // Build 4.1.1.0 (ERP #11124)
    case actions.LOAD_AVAILABLE_DYNAMIC_PRODUCTS: {
      const tempProducts = JSON.parse(JSON.stringify(action.dynamicProducts));
      tempProducts.forEach((product,ind) => {
        product.id = ind;
      });
      return { ...state, dynamicProducts: tempProducts };
    }
    // Build 4.1.1.0 (ERP #11124)
    case actions.SET_SALESMANLIST: {
      return { ...state, salesmanList: action.salesmanList };
    }
    case actions.SUBS_SET_SEARCH_SUBS: {
      console.log({action})
      return { ...state, searchedSubs: action.payload.data[0].subscription };
    }
    default:
      return state;
  }
};

export default subscriptionReducer;
